import { localQueryKey } from "hooks/useTypedQuery";

const component = "WebSocket";

type WebSocketStatus = {
  isConnected: boolean;
};

export const WebSocketKeys = {
  webSocketStatus: localQueryKey<WebSocketStatus>({ component, data: "webSocketStatus" })
};
